// hooks/useModuleSummary.js
import { useMemo } from "react";

export const STATUS_LABELS = {
  DOCUMENT_UPLOADED: "Document Uploaded",
  FORWARD_TO_JE: "Forwared To Junior Engineer",
  FORWARD_TO_AE: "Forwarded To AE",
  FORWARD_TO_ATP: "Forwarded To ATP",
  FORWARD_TO_DEPARTMENT: "Forwarded To Department",
  FORWARD_TO_EE_TP: "Forwarded To EE/TP",
  PENDING_AT_CTP: "Forwarded To CTP",
  PAYMENT_PENDING: "Pay Application Fees",
  FINAL_PAYMENT_PENDING: "Final Payment Pending",
  SEND_BACK_TO_APPLICANT: "Send back to Applicant",
  APPROVED: "Approved",
  FORWARD_TO_ADDITIONAL_SECRETORY_SECRETORY: "Forwarded To Additional Secretory",
  APPLY_FOR_DSC: "Apply For DSC",
  UPLOAD_DOC: "Draft",
  MAKE_PAYMENT: "Make Payment",
  FORWARD_TO_PO: "Forwarded To PO",
  MAKE_PAYMENT_SELF: "Make Payment Self",
  MAKE_PAYMENT_APPLICATION_FEE_FIRST: "Make Payment Application Fee First",
  FORWARD_TO_NODAL: "Forwarded To Nodal",
  GENERATE_APPROVAL_LETTER: "Generate Approval Letter",
  APPROVED_JE: "Apprved By JE",
  FORWARD_TO_APA: "Forwarded To APA",
  MAKE_PAYMENT_SELF_REGENERATE: "Make Pyment Self Regenerate",
  FORWARD_TO_CTP: "Forwarded To CTP",
  SENDBACK_TO_CITIZEN: "Send Back To Citizen",
  FORWARD_TO_Architectural_Assistant: "Forwarded to AA",
  MAKE_PAYMENT_APPLICATION_FEE: "Make Payment Aplication Fees",
  FORWARD_TO_CTP_FINAL_LEVEL: "Forwarded To CTP",
  FORWARD_TO_ND_OFF_AWAS: "Forwarded To Nodal AWAS BANDHU",
  REVERT_TO_APPLICANT: "Shortfall",
  MAKE_PAYMENT_BY_ARCHITECT: "Make Payment By Architect",
  EE_TP_AFTER_PAYMENT: "Sent to EE/TP After Payment",
  CTP_AFTER_PAYMENT: "Sent to CTP After Payment",
  REJECTED: "Rejected",
};

const useModuleSummary = (apiData) => {
  const moduleSummary = useMemo(() => {
    const misData = apiData?.MisData || [];

    const grouped = misData.reduce((acc, item) => {
      const module = item?.modulename;

      if (!acc[module]) {
        acc[module] = {
          moduleName: module,
          total: 0,
          approved: 0,
          draft: 0,
        };
      }

      acc[module].total += 1;

      if (item?.latestStatus === "APPROVED") {
        acc[module].approved += 1;
      } else {
        acc[module].draft += 1;
      }

      return acc;
    }, {});

    return Object.values(grouped);
  }, [apiData?.MisData]);

  return moduleSummary;
};

export const prepareDashboardData = (data = [], selectedModule = "") => {
  // Filter data according to selected module
  const filteredData = selectedModule ? data.filter((item) => item.modulename === selectedModule) : data;

  // Module dropdown should always contain ALL modules
  const moduleNames = [...new Set(data.map((item) => item.modulename).filter(Boolean))];

  // Statuses should come from filtered data
  const statuses = [...new Set(filteredData.map((item) => item.latestStatus).filter(Boolean))];

  const grouped = {};

  filteredData.forEach((item) => {
    const authority = item.developmentAuthorityName || "Unknown";

    if (!grouped[authority]) {
      grouped[authority] = {
        developmentAuthorityName: authority,
        grandTotal: 0,
      };

      statuses.forEach((status) => {
        grouped[authority][status] = 0;
      });
    }

    grouped[authority][item.latestStatus]++;

    grouped[authority].grandTotal++;
  });

  return {
    moduleNames,
    statuses,
    tableData: Object.values(grouped),
  };
};
export default useModuleSummary;
